export const obtenerValorReserva = ({entidad, habitacion, numNoches})=>{


    console.log(entidad)

    let numAdultos = entidad.numAcompanantes
    let total = 0
    if (numAdultos <= 1) {
        total = habitacion.tarifa
    }else if (numAdultos === 2) {
        total = habitacion.tarifaAcompanante
    }else if (numAdultos > 2) {
        total = entidad.numAcompanantes * habitacion.tarifaAdultos
    }

    //Agregar Valor niños

    if (entidad.numNinos > 0){
        total = total + (entidad.numNinos * habitacion.tarifaNinos)
    }

    return total * parseInt(numNoches)

}